import { render, staticRenderFns } from "./HowToUseComponent.vue?vue&type=template&id=6327484a"
import script from "./HowToUseComponent.vue?vue&type=script&lang=js"
export * from "./HowToUseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports